
import { Action } from '../Actions'
import { filteredAgentsList } from './WorkersFilters';

const UPDATE_WORKERS_LIST = 'UPDATE_WORKERS_LIST'
const UPDATE_WORKER_ITEM = 'UPDATE_WORKER_ITEM'
const UPDATE_WORKERS_FILTER_SEARCH = 'UPDATE_WORKERS_FILTER_SEARCH'
const UPDATE_WORKERS_FILTER_DEPARTMENT = 'UPDATE_WORKERS_FILTER_DEPARTMENT'
const UPDATE_WORKERS_FILTER_TYPE = 'UPDATE_WORKERS_FILTER_TYPE'

const UPDATE_QUEUES_LIST = 'UPDATE_QUEUES_LIST'
const UPDATE_QUEUE_ITEM = 'UPDATE_QUEUE_ITEM'

const UPDATE_TASKS_LIST = 'UPDATE_TASKS_LIST'
const UPDATE_TASK_ITEM = 'UPDATE_TASK_ITEM'


const initialState: WorkersState = {
    tasks : [],
    queues : [],
    workers : [],
    filteredWorkers : [],
    filters : {
        type : true
    }
}

export interface WorkersState {
    tasks: any[],
    queues: any[],
    workers: any[],
    filteredWorkers: any[],
    filters: any
}

export class WorkersActions {
    static updateQueuesList = (queues : any): Action => ({ type: UPDATE_QUEUES_LIST, payload : { queues : queues }})
    static updateQueueItem = (queue : any): Action => ({ type: UPDATE_QUEUE_ITEM, payload : { queue : queue }})

    static updateTasksList = (tasks : any): Action => ({ type: UPDATE_TASKS_LIST, payload : { tasks : tasks }})
    static updateTaskItem = (task : any): Action => ({ type: UPDATE_TASK_ITEM, payload : { task : task }})

    static updateWorkersList = (workers : any): Action => ({ type: UPDATE_WORKERS_LIST, payload : { workers : workers }})
    static updateWorkerItem = (worker : any): Action => ({ type: UPDATE_WORKER_ITEM, payload : { worker : worker }})
    static updateWorkersFilterSearch = (phrase : any): Action => ({ type: UPDATE_WORKERS_FILTER_SEARCH, payload : { phrase : phrase }})
    static updateWorkersFilterDepartment = (departmentId : any): Action => ({ type: UPDATE_WORKERS_FILTER_DEPARTMENT, payload : { departmentId : departmentId }})
    static updateWorkersFilterType = (type : any): Action => ({ type: UPDATE_WORKERS_FILTER_TYPE, payload : { type : type }})
}

export function reduce(state: WorkersState = initialState, action: Action) {
    switch (action.type) {
        case UPDATE_WORKERS_LIST: {
            return {
                ...state,
                workers: action.payload.workers,
                filteredWorkers : filteredAgentsList(state, action.payload)
            }
        }
        case UPDATE_WORKER_ITEM: {
            const sid = action.payload?.worker?.worker_sid;
            let updatedWorker : any = {};

            if ( state.workers[sid] ) {
                updatedWorker[sid] = action.payload?.worker;
            }

            let workers = {
                ...state.workers,
                ...updatedWorker
            };
 
            return {
                ...state,
                ...{
                    workers : workers,
                    filteredWorkers : filteredAgentsList(state, { workers })
                }
            }
        }
        case UPDATE_WORKERS_FILTER_SEARCH: {
            const phrase = action.payload.phrase;
            
            let workers = {
                ...state.workers,
            };
            let filters = {
                ...state.filters,
                phrase : phrase
            };

            return {
                ...state,
                ...{
                    workers : workers,
                    filteredWorkers : filteredAgentsList({ filters }, { workers }),
                    filters : filters
                }
            }
        }
        case UPDATE_WORKERS_FILTER_DEPARTMENT: {
            const departmentId = action.payload.departmentId;
            let workers = {
                ...state.workers,
            };
            let filters = {
                ...state.filters,
                departmentId : departmentId
            };

            return {
                ...state,
                ...{
                    workers : workers,
                    filters : filters,
                    filteredWorkers : filteredAgentsList({ filters }, { workers })
                }
            }
        }
        case UPDATE_WORKERS_FILTER_TYPE: {
            const type = action.payload.type;

            return {
                ...state,
                ...{
                    workers : {
                        ...state.workers,
                    },
                    filters : {
                        ...state.filters,
                        type : type
                    }
                }
            }
        }

        case UPDATE_QUEUES_LIST: {
            return {
                ...state,
                queues: action.payload.queues,
            };
        }

        case UPDATE_QUEUE_ITEM: {
            const sid = action.payload?.queue?.queue_sid;
            let updatedQueue : any = {};

            if ( state.queues[sid] ) {
                updatedQueue[sid] = action.payload?.queue;
            }

            return {
                ...state,
                ...{
                    queues : {
                        ...state.queues,
                        ...updatedQueue
                    }
                }
            }
        }

        case UPDATE_TASKS_LIST: {
            return {
                ...state,
                tasks: action.payload.tasks,
            };
        }

        case UPDATE_TASK_ITEM: {
            const sid = action.payload?.task?.task_sid;
            let updatedTask : any = {};

            //if ( state.tasks[sid] ) {
                updatedTask[sid] = action.payload?.task;
            //}

            return {
                ...state,
                ...{
                    tasks : {
                        ...state.tasks,
                        ...updatedTask
                    }
                }
            }
        }

        default:
            return state;
    }
}

